export default "__VITE_ASSET__a5a14946__"